import { api } from "../api";

/**
 * findAllStatesByCountryIdListResponse - Function that finds on database all states by country id as select list   
 * /states/{countryId}  
 * method GET 
 * @async-function
 */
const findAllStatesByCountryIdListResponse = async (token: string, countryId: number) => {
    const response = await api.get(
        `/states/${countryId}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
         }
    );
    return response;
};
export default findAllStatesByCountryIdListResponse;